<script>

	import { mapState } from 'vuex'

	import Page from '@/containers/Page/Page'

	import Companies from '@/components/Companies/Companies'

	import './style.scss'

	export default {
		name: 'lander',
		components: {
			Page,
			Companies,
		},
		computed: {
			...mapState({
				'isLoggedIn': state => state.user.isLoggedIn,
				'companies': state => state.user.companies,
			})
		},
	}

</script>

<template>
	<Page class='lander'>
		<div class='container'>
			<Companies :companies='companies'/>
		</div>
	</Page>
</template>



// WEBPACK FOOTER //
// src/flows/Lander/Lander.vue